import React from "react";
import { ContactFormProps } from "../types";
import { Loader } from "lucide-react";

export const ContactForm: React.FC<ContactFormProps> = ({ onSubmit, isLoading, error, setError }) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);

    try {
      onSubmit(Object.fromEntries(formData) as any);
      !error && form.reset(); // Clear the form after successful submission
    } catch (err) {
      setError?.("An error occurred. Please try again."); // Set error message if needed
    }
  };



  return (
    <form
      onSubmit={handleSubmit}
      className="relative flex flex-col w-full max-w-[500px] mx-auto text-white"
    >
      {/* Contact Us Header */}
      <h2 className="text-3xl font-poppins text-[#57c0af] mb-6 text-center">
        Contact Us
      </h2>

      {/* Name Input */}
      <label htmlFor="name" className="sr-only">
        Name
      </label>
      <input
        id="name"
        name="name"
        type="text"
        required
        className="px-6 py-3 mt-4 bg-black border border-gray-600 rounded-lg placeholder-gray-400 focus:outline-none focus:ring focus:ring-[#57c0af]"
        placeholder="Name"
      />

      {/* Email Input */}
      <label htmlFor="email" className="sr-only">
        Email
      </label>
      <input
        id="email"
        name="email"
        type="email"
        required
        className="px-6 py-3 mt-4 bg-black border border-gray-600 rounded-lg placeholder-gray-400 focus:outline-none focus:ring focus:ring-[#57c0af]"
        placeholder="Email"
      />

      {/* Phone Input */}
      <div className="flex items-center mt-4 bg-black border border-gray-600 rounded-lg">
        <div className="flex items-center px-3">
          <span className="text-white">+91</span>
        </div>
        <input
          type="tel"
          name="phone"
          minLength={10}
          maxLength={10}
          required
          className="w-full px-4 py-3 bg-transparent border-none rounded-lg placeholder-gray-400 focus:outline-none focus:ring focus:ring-[#57c0af]"
          placeholder="Phone number"
        />
      </div>

      {/* Message Input */}
      <label htmlFor="message" className="sr-only">
        Message
      </label>
      <textarea
        id="message"
        name="message"
        required
        className="px-6 py-3 mt-4 bg-black border border-gray-600 rounded-lg placeholder-gray-400 resize-none focus:outline-none focus:ring focus:ring-[#57c0af]"
        placeholder="Message"
        rows={4}
      ></textarea>

      {/* Submit Button */}
      <button
        type="submit"
        className="self-center px-6 py-2 mt-6 text-lg font-medium text-black bg-[#57c0af] rounded-xl shadow hover:bg-[#57c0af] focus:outline-none focus:ring focus:ring-[#57c0af] w-[8rem]"
      >
        {isLoading ? <Loader className="mx-auto" /> : "Submit"}
      </button>
      <p className="absolute left-1/2 top-[102%] transform -translate-x-1/2 text-red-600">
        {error ? error : ""}
      </p>    </form>
  );
};
